import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextStruct = () => {

return(
<div>
    
<Typography variant="h6" >
<br />
Structural Variants are genetic alterations of more than 50 base pairs. 
These include deletions, duplications, insertions, inversions, and translocations, as well as complex rearrangements.
  <br />  <br /> 
  The pipeline to find structural variants in your genome (GATK Best Practices for Structural Variation Discovery on Single Samples) identifies genotype, and annotate structural variation from the following variant types:
  <br />  <br /> 
-   Copy number variants, including deletions and duplications<br /> 
-   Insertions<br /> 
-   Inversions<br /> 
-   Reciprocal chromosomal translocations<br /> 
-   Additional forms of complex structural variation
<br /> <br /> <br /> <br />

<Typography component="span" variant="h5" sx={{fontWeight: '600'}}>SVs related to obesity:</Typography>

<br /> <br />
1 &nbsp;&nbsp;near NEGR1 -- 1p31.1 45-kb deletion (encodes a cell-adhesion molecule expressed in the brain) - Lead SNP rs2815752  <br /><br />
2 &nbsp;&nbsp;upstream of gene GPRC5B -- 16p12.3 21-kb deletion  (modulates insulin secretion probably) <br /> <br />
3 &nbsp;&nbsp;PPYR1 (known as NPY4R): 10q11.22 CNV (encodes a potent anti-obesity agent known to inhibit food intake) <br /> <br />
4 &nbsp;&nbsp;encompassing AMY1A: the 1p21.1 multi-allele CNV (produces salivary alpha-amylase, key enzyme in starch digestion) 
<br /> <br />

</Typography>

</div>
)
}